import React, { useEffect, useState } from "react";

import Select from "react-select";

import ReactDatetime from "react-datetime";

import moment from "moment";
import apiService from "../../variables/apiService.js";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip,
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import DatePicker from "../../components/DatePicker/Datepicker.js";
import { withRouter } from "react-router-dom";

import {
  Whatsapp_CAMPAIGN_REPORTS,
  WHATSAPP_CAMPAIGN_LIST_DATE,
  WHATSAPP_DAYWISE_EXCEL
} from "../../constants.js";
import axios from "axios";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import autoTable from "jspdf-autotable";
import LoadingScreen from "react-loading-screen";
//import logo from "../../../assets/img/logo.png";
import logo from "../../assets/img/logo.png";

let templates = [];
let senderids = [];
let campaigns=[]
const localJson = localStorage.getItem("user");
const user= JSON.parse(localJson)
const CampaignReports = (props) => {
  const [daywiseList, setDaywiseList] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorhandle,setErrorHandle]= useState()


  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    templateid:"",
    campaignname:"",
    senderid:""
  });
  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });





  const submitHandler = async () => {
   

    const isValid=validatedate();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length==0){
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
   

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);

    const  payload={
        fromdate:fromdate,
        todate: todate ,
        client_id:user.client,
        campaign:search?.campaignname?.value,
        channel:"email"
      }
    
  
    setIsLoading(true)
    await apiService
      .postData(
        Whatsapp_CAMPAIGN_REPORTS ,payload
       
      )
      .then((res) => {
        setDaywiseList(res.data);
        setIsLoading(false)
      })
      .catch((err) => console.log("error====>", err));
    }
  };
  const validatedate=()=>{
    let errors={}
    if(!search.fromdate){
      errors.fromdate="Please Select From Date"
    }  if(!search?.todate){
      errors.todate="Please Select To Date"
    }

   
    return errors;
   }


   const downloaddaywiseexcel = async (date) => {
    const isValid=validatedate();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length==0){
    setIsLoading(true)
    let fromdate = moment(date).format("YYYY-MM-DD");
    let todate = moment(date).format("YYYY-MM-DD");
   

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);

    const  payload={
        fromdate:fromdate,
        todate: todate ,
        client_id:user.client,
        campaign:search?.campaignname?.value,
        channel:"sms"
      }
       await apiService
       .postData(
        WHATSAPP_DAYWISE_EXCEL ,payload
        
       )
         .then((res) => {
           setIsLoading(false)
           const body =
             res.data.message.length > 0 ? res.data.message : "No Records";
         
             const fileType =
               "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
 
             const fileExtension = ".xlsx";
             const ws = XLSX.utils.json_to_sheet(body);
             const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
             const excelBuffer = XLSX.write(wb, {
               bookType: "xlsx",
               type: "array",
             });
             const data = new Blob([excelBuffer], { type: fileType });
             FileSaver.saveAs(data, todate + fileExtension);
          
         })
         .catch((err) => console.log("error====>", err));
        }
   };




  const toDatevalidation = async(todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
      const payload={
        fromdate:fromdate,
        todate:todate,
        client_id:user?.client,
        channel:"email"
      }
      
      await apiService.postData(WHATSAPP_CAMPAIGN_LIST_DATE,payload).then(res=>{
        console.log(res?.data.message);
        res?.data?.message?.map((item,index)=>{
          campaigns.push({label:item.campaign,value:item.campaign})
        });
        
      }).catch(e=>{
        console.log("Error==>",e);
      })
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };

  
  const downloadexcel = async () => {
    const isValid=validatedate();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length==0){
    setIsLoading(true)
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
   

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);

    const  payload={
        fromdate:fromdate,
        todate: todate ,
        client_id:user.client,
        campaign:search?.campaignname?.value,
        channel:"email"
      }
       await apiService
       .postData(
        Whatsapp_CAMPAIGN_REPORTS ,payload
        
       )
         .then((res) => {
           setIsLoading(false)
           const body =
             res.data.message.length > 0 ? res.data.message : "No Records";
         
             const fileType =
               "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
 
             const fileExtension = ".xlsx";
             const ws = XLSX.utils.json_to_sheet(body);
             const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
             const excelBuffer = XLSX.write(wb, {
               bookType: "xlsx",
               type: "array",
             });
             const data = new Blob([excelBuffer], { type: fileType });
             FileSaver.saveAs(data, todate + fileExtension);
          
         })
         .catch((err) => console.log("error====>", err));
        }
   };


  return (
    <>
      <div className="content pb-0">
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <Row>
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                       
                      }}
                    />
                    <span style={{color:"red"}}>{errorhandle?.fromdate}</span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        toDatevalidation(val._d);
                      //  fetchCampaigns()
                      }}
                      // onChange={(val) =>{setSearch({...search,todate:val._d});setValidate({
                      //   message:"",
                      //   notValid:false
                      // } )}}
                    />
                   <span style={{color:"red"}}>{errorhandle?.todate}</span>
                   <span style={{color:"red"}}>{validate?.message}</span>
                   
                  </Col>

                  <Col md="2" sm='12'>
                    <p className="category">Select </p>
                  <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          value={search?.campaignname}
                          onChange={(value) => {
                            setSearch({...search,campaignname:value})
                           
                            }}
                          options={campaigns}
                          placeholder="Select"
                        />
                    </Col>
                    
                   

                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitHandler()}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                   
                    <Button
                      className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right"
                      color="primary"
                      data-placement="top"
                      id="tooltipexcel"
                      type="button"
                      onClick={() =>downloadexcel()}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipexcel"
                    >
                      Excel
                    </UncontrolledTooltip>
                   </Col>
                </Row>
                <Row>
                  
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
              <CardBody className="mb-0">
              <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
                <TableContainer component={Paper}  className="tableheight">
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th rowspan="2">S no </th>
                        <th rowspan="2"> Date</th>
                        {/* <th>Submitted </th> */}
                        <th>Sent </th>
                        <th> Delivery</th>
                        <th> Fail </th>
                        <th> Action </th>
                      
                      </tr>
                     
                    </thead>
                    <tbody>
                 
                      {daywiseList?.message?.length > 0 ? (
                        daywiseList?.message?.map((row, index) => (
                          <tr
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td>{index + 1}</td>
                            <td> {moment(row.date).format("YYYY-MM-DD")}</td>
                           
                            <td>{row.sent}</td>
                            <td>{row.deliver}</td>
                            <td>{row.failed}</td>
                            <td><span
                     
                      color="primary"
                      data-placement="top"
                      id="tooltipexcel"
                      type="button"
                      onClick={() => downloaddaywiseexcel(row.date,1)}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </span></td>
                          </tr>
                        ))
                      ) : (
                        <tr
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <td colSpan={9}>No Records</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
              {/* <Row>
              <Col md="12" >
          <Pagination  className='pull-right'>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Previous"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-left"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Next"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-right"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
          </Col>
              </Row> */}
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(CampaignReports);
